<script setup lang='ts'>
const props = withDefaults(defineProps<{
  active?: number
  custom?: any
  top?: string
  width?: string
  score?: number
}>(), {
  active: -1,
  custom: () => ({
    childCount: 1,
    componentsList: [{ title: 'title' }],
  }),
  top: '0px',
  width: '60px',
  score: undefined,
})

const currentStep = props.custom
const currentActive = computed(() => {
  return (props.active === -1 || props.active > currentStep.childCount - 1) ? currentStep.childCount - 1 : props.active
})
const steps = currentStep.componentsList.map((item: any) => {
  const icon = item?.i ? h('i', { class: item.i }) : null
  return {
    title: item.title,
    icon,
  }
})

const count = computed(() => {
  return currentStep.childCount ? currentStep.childCount : 6
})
</script>

<template>
  <div
    class="grid justify-between relative flex-1 step w-100% col-custom"
    :class="[`col-${count}`]"
    :style="[`--activeTotal:${count}`, `--active:${currentActive}`, `--top:${props.top}`, props.width ? `--colWidth:${props.width}` : '']"
  >
    <div
      v-for="(v, i) in steps" :key="i" :title="v.title"
      class="step-item" :class="[active >= i || active === -1 ? 'is-active' : '']"
    >
      <slot :item="v" :index="i">
        <div class="text-white step-item__icon">
          <component :is="v.icon" />
        </div>
        <div class="text-3.5 whitespace-nowrap">
          {{ v.title }}
        </div>
      </slot>
    </div>
    <div class="step-line">
      <div class="is-active" />
    </div>
  </div>
</template>

<style lang='scss' scoped>
.step {
  --activeTotal: 7;
  --active: 0;
  --top: 0px;
  --colWidth: calc(100% / var(--activeTotal));

  &.col-custom {
    grid-template-columns: repeat(var(--activeTotal), var(--colWidth));
  }

  &-item {
    --uno: z-1 text-slate-3 text-center relative flex flex-col items-center justify-start;

    .svg-icon {
      width: min(60px, var(--colWidth));
      height: min(60px, var(--colWidth));
    }

    &__icon {
      background: var(--el-color-info-light);
      border-radius: 50%;
      border: 4px solid #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      width: calc(min(60px, var(--colWidth)) + 8px);
      height: calc(min(60px, var(--colWidth)) + 8px);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5px;
      font-size: 40px;
    }

    &.is-active {
      --uno: text-blue-5;
    }

    .is-active &__icon {
      background: linear-gradient(135deg, #6ad5e5, #488afa);
    }
  }

  &-line {
    width: calc(100% - var(--colWidth));
    height: 16px;
    position: absolute;
    box-sizing: border-box;
    top: calc((min(60px, var(--colWidth)) + 8px) / 2 + var(--top));
    margin: 0 calc(var(--colWidth) / 2);
    transform: translateY(-50%);
    --uno: bg-slate-3;

    .is-active {
      width: calc((100% / (var(--activeTotal) - 1)) * calc(var(--active)));
      height: 100%;
      background: linear-gradient(180deg, #60beeb 0%, #488afa 100%);
    }
  }
}
</style>
